module.exports = "/src/views/games/other/images/action/cure.png";